import * as React from 'react';
import { Paragraph } from '../../../../elements';
const CourtRow = ({ value, formatDate }) => (React.createElement(React.Fragment, null, value.courts.map((item, index) => (React.createElement(React.Fragment, { key: index },
    React.createElement("div", { className: "ReadReport__Table__Row" },
        React.createElement("div", { className: "ReadReport__Table__Col" },
            React.createElement(Paragraph, null, item.name)),
        React.createElement("div", { className: "ReadReport__Table__Col" },
            React.createElement(Paragraph, null, formatDate(item.verificationDate)))))))));
export default CourtRow;
